
const optionId = {
    GAPS_CERTIFICADOS: '1207',
    GAPS_TRANSFERENCIA: '1208',
    GAPS_GAP: '1209',
    GAPS_DALI: '111111002',
}

module.exports = optionId;
